import { render } from "./ResultsLongTerm.vue?vue&type=template&id=274a7577"
import script from "./ResultsLongTerm.vue?vue&type=script&lang=js"
export * from "./ResultsLongTerm.vue?vue&type=script&lang=js"

import "./ResultsLongTerm.vue?vue&type=style&index=0&id=274a7577&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__